import { useState, useRef } from 'react'

import { Player } from '@lottiefiles/react-lottie-player'

import styles from './expandable_infographic.module.sass'

import classNames from 'classnames'

import BlockWrapper from './layout/block_wrapper'
import Image from './basic/image'
import Button from './basic/button'
import ScrollAnimation from './layout/scroll_animation'


function ExpandableInfographic(props) {
	const infographicRef = useRef(null)
	const [expanded, setExpanded] = useState(false)
	let fields = props.fields

	return <BlockWrapper {...props} className={classNames(styles.expandable_infographic )}>
		<ScrollAnimation styles={styles}>
			<div className={classNames(styles.expandable_infographic_wrapper, styles[fields.infographic_orientation], expanded ? styles.expanded : '')}>	
				<div ref={infographicRef} className={styles.infographic_wrapper}>
					{fields.infographic && !fields.animated_infographic && <Image {...fields.infographic} className={styles.infographic} />}
					{fields.infographic_animated && fields.animated_infographic && 
						<Player
						autoplay
						loop
						controls={false}
						style={{width: '100%', height: '100%'}}
						src={fields.infographic_animated.url}
					/>}
					<span className={styles.expander} onClick={() => setExpanded(prevExpanded => !prevExpanded)} />
				</div>

				<div className={styles.content_wrapper}>
					{fields.title &&
						<h3 className={styles.title} dangerouslySetInnerHTML={{__html: fields.title}}></h3>
					}
					{fields.content &&
						<div className={styles.content} dangerouslySetInnerHTML={{__html: fields.content}} />
					}
					{fields.logo && <Image {...fields.logo} className={styles.logo} />}
					{fields.button && 
						<Button fields={{button: fields.button, button_style: fields.button_style, button_color: fields.button_color}}>{fields.button.title}</Button>
					}

				</div>
			</div>
		</ScrollAnimation>
	</BlockWrapper>
}

export default ExpandableInfographic